package org.hs_soft.runmynesto.domain.model.home.user.add_new_user


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CreateMutation(
    @SerialName("id")
    val id: String?,
    @SerialName("name")
    val name: String?
)